import React from 'react';
import MultiColumnsSelection from '../components/multiColumnsDropDown/MultiColumnsSelection';
import { useQuery, gql } from '@apollo/client';
import { Paper, Box, Grid, Typography } from '@material-ui/core';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import CircularProgress from '@material-ui/core/CircularProgress';
import SearchIcon from '@material-ui/icons/Search';
import { makeStyles } from '@material-ui/core/styles';
import VirtualizedTable from '../components/virtualized/VirtualizedTable';
const useStyles = makeStyles(theme => ({
  root: {
    padding: '2px 2px',
    display: 'flex',
    alignItems: 'center',
    width: '40%'
  },
  input: {
    // marginLeft: theme.spacing(1)
    // flex: 1
    width: '300px'
  },
  iconButton: {
    padding: 2
  },
  tableRoot: {
    width: '100%',
    height: '90%'
  },
  container: {
    maxHeight: '90%'
  },
  verseLoc: {
    textAlign: 'right'
  }
}));
function TimKiem() {
  const [bible, setBible] = React.useState({
    version: 'V02',
    book: 'All',
    bookSelectedIndex: 0,
    versionSelectedIndex: 0,
    searchVersion: 'All',
    searchText: ''
  });
  const [searchText, setSearchText] = React.useState('');
  const versionsQuery = gql`
    {
      versions {
        id
        name
        shortName
        language
      }
    }
  `;
  const booksQuery = gql`
    query($id: String!) {
      bible(id: $id) {
        id
        name
      }
    }
  `;

  const textQuery = gql`
    query($text: String!, $version: String, $book: String) {
      searchText(text: $text, versionId: $version, bookId: $book) {
        id
        version
        bookName
        chapterNum
        verseNum
        verseText
      }
    }
  `;
  const { data: versions } = useQuery(versionsQuery);
  const { data: booksData } = useQuery(booksQuery, {
    variables: { id: bible.version }
  });
  const { data: resultsData, loading } = useQuery(textQuery, {
    variables: {
      text: bible.searchText,
      version: bible.searchVersion === 'All' ? undefined : bible.searchVersion,
      book: bible.book === 'All' ? undefined : bible.book
    }
  });

  const vietLang = versions?.versions?.filter(version => version.language === 'Tiếng Việt');
  const versionList = vietLang && [{ id: 'V00', name: 'Tất Cả Bản Dịch' }, ...vietLang];
  const booksList = booksData?.bible && [
    { id: 'V02B00', name: 'Tất Cả Sách' },
    ...(booksData && booksData.bible)
  ];
  const versionChange = index => {
    const selectedVersion = versionList[index].id;
    setBible({
      ...bible,
      searchVersion: selectedVersion === 'V00' ? 'All' : selectedVersion,
      versionSelectedIndex: index
    });
  };

  const bookChange = index => {
    const selectedBook = booksList && booksList[index];
    const subBookId = selectedBook.id.substr(3);
    setBible({
      ...bible,
      book: subBookId === 'B00' ? 'All' : subBookId,
      bookSelectedIndex: index
    });
  };

  const handleSearchClick = e => {
    e.preventDefault();
    setBible({
      ...bible,
      searchText: searchText
    });
  };

  const classes = useStyles();
  const getHighlightedText = (text, highlight) => {
    const parts = text.split(new RegExp(`(${highlight})`, 'gi'));
    return (
      <span>
        {parts.map(
          (part, i) =>
            part.toLowerCase() === highlight.toLowerCase() ? <mark key={i}>{part}</mark> : part
        )}
      </span>
    );
  };
  const columns = [
    {
      name: 'Bản Dịch',
      key: 'version',
      width: 2,
      render: (value, row) => <span>{row.version}</span>
    },
    {
      name: 'Sách',
      key: 'book',
      width: 2,
      render: (value, row) => <span>{row.bookName}</span>
    },
    {
      name: 'Đoạn',
      key: 'chapter',
      width: 1,
      render: (value, row) => <span>{row.chapterNum}</span>
    },
    {
      name: 'Kinh Văn',
      key: 'text',
      width: 6,
      render: (value, row) => (
        <span>
          {/* {row.verseText.concat('  ' + row.bookName + ' ' + row.chapterNum + ':' + row.verseNum)} */}
          {/* {row.verseText} */}
          {getHighlightedText(row.verseText, bible.searchText)}
          {<br />}
          <div className={classes.verseLoc}>
            {row.bookName} {row.chapterNum}
            {':'}
            {row.verseNum}
          </div>
        </span>
      )
    }
  ];
  const getItemSize = index => {
    const row = resultsData && resultsData.searchText[index];
    const textLength = (row && row.verseText.length) || 0;
    if (textLength > 100 && textLength <= 150) {
      return 110;
    } else if (textLength > 150 && textLength <= 200) {
      return 130;
    } else if (textLength > 200 && textLength <= 300) {
      return 160;
    } else if (textLength > 300 && textLength <= 500) {
      return 190;
    } else if (textLength > 500) {
      return 220;
    } else {
      return 100;
    }
  };
  return (
    <div>
      <Box display="flex" justifyContent="center" alignItems="center">
        <Grid container item xs={10}>
          <Paper component="form" className={classes.root}>
            <form onSubmit={handleSearchClick}>
              <InputBase
                className={classes.input}
                placeholder="Tìm Kiếm Trong Các Bản Dịch Tiếng Việt"
                inputProps={{ 'aria-label': 'search language Viet' }}
                onChange={e => setSearchText(e.target.value)}
              />
              <IconButton type="submit" className={classes.iconButton} aria-label="search">
                <SearchIcon />
              </IconButton>
            </form>
          </Paper>
          <MultiColumnsSelection
            id="versionsList"
            cols={1}
            data={versionList}
            onSelect={versionChange}
            defaultValue={bible.versionSelectedIndex}
          />
          <MultiColumnsSelection
            id="booksList"
            cols={2}
            data={booksList}
            onSelect={bookChange}
            defaultValue={bible.bookSelectedIndex}
          />
        </Grid>
      </Box>
      {/* <Grid container item xs={12}> */}
      <Paper className={classes.tableRoot}>
        {loading ? (
          <CircularProgress />
        ) : (
          <div>
            <p />
            <Typography variant="h5" key="searchReport">
              {resultsData &&
                'Tìm thấy ' + resultsData.searchText.length + ' câu có chữ ' + bible.searchText}
              <p />
            </Typography>
            <VirtualizedTable
              data={resultsData && resultsData.searchText}
              columns={columns}
              // cellRenderer={renderBodyCell}
              getItemSize={getItemSize}
            />
          </div>
        )}
      </Paper>
      {/* </Grid> */}
    </div>
  );
}
export default TimKiem;
